import styled from 'styled-components';
import { Typography } from '@mui/material';

import colors from '../../../../../styles/colors';

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 85vh;
`;

const ModalHeader = styled.div`
  padding: 24px 24px 16px;
  border-bottom: 1px solid ${colors.shades.gamma3};
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

const ModalHeaderIcon = styled.div`
  display: flex;
  align-items: center;
  padding-top: 2px;
  color: ${colors.base.secondary2};
  flex-shrink: 0;
`;

const ModalHeaderContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const ModalTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

const ModalTitle = styled(Typography)`
  font-size: 18px;
  font-weight: 700;
  color: ${colors.base.secondary2};
`;

const ModalSubtitle = styled(Typography)`
  font-size: 13px;
  color: ${colors.shades.gamma10};
`;

const ModalBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ModalFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid ${colors.shades.gamma3};
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;

export {
  ModalContainer,
  ModalHeader,
  ModalHeaderIcon,
  ModalHeaderContent,
  ModalTitleRow,
  ModalTitle,
  ModalSubtitle,
  ModalBody,
  ModalFooter,
};
